import { createApi } from 'store/slices/createApi';
import { createBaseQuery } from '../../slices';
import { TAG_TYPES } from 'types/services';

export const flowApi = createApi({
  reducerPath: 'flowApi',
  baseQuery: createBaseQuery({
    extendedUrl: 'Flow',
  }),

  tagTypes: [
    TAG_TYPES.TABLE,
    TAG_TYPES.TABLE_DETAIL,
    TAG_TYPES.NOTIFICATION_TEMPLATES,
    TAG_TYPES.VIEWS,
    TAG_TYPES.VIEW,
    TAG_TYPES.AGENDAS,
    TAG_TYPES.CONDITIONS,
    TAG_TYPES.LOOKUPS,
    TAG_TYPES.AGENDAS_FAVORITE,
    TAG_TYPES.AGENDAS_IMPORTS,
    TAG_TYPES.RECORDS,
    TAG_TYPES.COLUMNS,
    TAG_TYPES.SHARED_NOTIFICATIONS,
    TAG_TYPES.USER_GROUPS,
    TAG_TYPES.CRM,
    TAG_TYPES.REST_API_CONNECTIONS,
  ],

  endpoints: () => ({}),
});
